import { useParams, useNavigate } from "react-router-dom";
import { blogPosts } from "./BlogsData";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import '../../styles/Header.css';
import { Helmet } from "react-helmet";

export default function BlogDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const blog = blogPosts.find((b) => b.id === id);

  if (!blog) return <p>Blog not found</p>;

  const renderList = (list) => {
    if (!list) return null;
    
    if (typeof list === 'string') {
      const items = list.split(/\n\n+/).filter(item => item.trim() !== '');
      return (
        <ul style={{ marginLeft: '1.5rem', paddingLeft: '1rem', listStyleType: 'disc' }}>
          {items.map((item, idx) => (
            <li key={idx} style={{ marginBottom: '0.5rem' }}>{item.trim()}</li>
          ))}
        </ul>
      );      
    }
    
    return (
      <ul style={{ marginLeft: '1.5rem', paddingLeft: '1rem', listStyleType: 'disc' }}>
        {list.map((item, idx) => (
          <li key={idx} style={{ marginBottom: '0.5rem' }}>{item}</li>
        ))}
      </ul>
    );
  };

  return (
    <div className="blogs-container">
      <Helmet>
        <title>{blog.metaTitle}</title>
        <meta name="description" content={blog.metaDescription} />
        {blog.jsonLd && (
    <script type="application/ld+json">
      {JSON.stringify(blog.jsonLd)}
    </script>
  )}
      </Helmet>
      <div className="back-button-wrapper">
        <Tooltip title="Back to Blogs List">
          <IconButton
            onClick={() => navigate("/blogs")}
            aria-label="go back"
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
      <h1 className="blog-title">{blog.title}</h1>
      {/* <img
        src={blog.image}
        alt={blog.title}
        className="blog-detail-image"
      /> */}

        {blog.subtitle && (
                <h2 className="blog-section-subtitle">{blog.subtitle}</h2>
              )}
              
              {blog.intro && (
                <div className="blog-intro" dangerouslySetInnerHTML={{ __html: blog.intro }} />
              )}
      
      {blog.content?.map((section, index) => (
        <div key={index} style={{ marginBottom: '2rem' }}>
          {section.subtitle && (
            <h2 className="blog-section-subtitle">{section.subtitle}</h2>
          )}
          
          {section.body && (
            <div dangerouslySetInnerHTML={{ __html: section.body }} />
          )}
          
          {section.list && renderList(section.list)}
          
          {section.table && (
            <table>
              <thead>
                <tr>
                  <th>Area</th>
                  <th>Actions Taken</th>
                </tr>
              </thead>
              <tbody>
                {section.table.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.area}</td>
                    <td>{row.action}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          
          {section.lists && Object.entries(section.lists).map(([title, items], idx) => (
            <div key={idx}>
              <h2 className="blog-section-subtitle">{title}</h2>
              <ul style={{ marginLeft: '1.5rem', paddingLeft: '1rem', listStyleType: 'disc' }}>
                {items.map((item, itemIdx) => (
                  <li key={itemIdx} style={{ marginBottom: '0.5rem' }}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
          
          {section.sections && section.sections.map((sub, subIdx) => (
            <div key={subIdx}>
             {sub.subtitle && <h3 className="blog-section-subtitle">{sub.subtitle}</h3>}
              {sub.body && <div dangerouslySetInnerHTML={{ __html: sub.body }} />}
              {sub.image && <img src={sub.image} alt={sub.subtitle} />}
              {sub.list && renderList(sub.list)}
            </div>
          ))}
        </div>
      ))}
      
      <p className="blog-content">{blog.conclusion}</p>
    </div>
  );
}